import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { ImageLeptin } from "./ImageLeptin";

import { TextLeptin } from "./TextLeptin";
import { SourcesLeptin } from "./SourcesLeptin";


export default function Dia_Leptin() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      

    <Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
    <TextCard 
            textcard={'Leptin Signaling Pathway'  }
           />
    </Button>

    <CustomDialog open={open} onClose={handleClose}

        title='Leptin Signaling Pathway'

        content={<TextLeptin />}

        image={ <ImageLeptin />}

        sources={<SourcesLeptin />}

    />

</>
)}